import React, { useState } from 'react';
import './Preloader.css';
import loading from '../../Assets/Loading.gif'
import { useEffect } from 'react';

const Preloader = () => {

const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

    return ( 
        <div className={`PLContainer ${!isVisible ? 'fadeOut' : ''}`}>
            <img className='Preloader' id='preloader' src={loading} alt="" />
        </div>
     );
}
 
export default Preloader;